import { render, staticRenderFns } from "./joystick.vue?vue&type=template&id=3db8970a&scoped=true&"
import script from "./joystick.vue?vue&type=script&lang=js&"
export * from "./joystick.vue?vue&type=script&lang=js&"
import style0 from "./joystick.vue?vue&type=style&index=0&id=3db8970a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db8970a",
  null
  
)

export default component.exports